import $ from '@vaersaagod/tools/Dom';
import Dispatch from '@vaersaagod/tools/Dispatch';
import Viewport from '@vaersaagod/tools/Viewport';
import Flickity from 'flickity';
import * as Events from '../lib/events';

export default (el, props) => {
    const dom = $(el);
    const toggle = dom.find('[data-gallery-toggle]');
    const flkty = [];
    const galleries = dom.find('[data-gallery]');

    const onToggle = e => {
        e.preventDefault();
        const node = e.triggerTarget;
        const activeGallery = galleries.filter(`#${$(node).data('gallery-toggle')}`);
        toggle.filter('.is-active').removeClass('is-active');
        $(node).addClass('is-active');
        galleries.filter('.is-active').removeClass('is-active');
        activeGallery.addClass('is-active');
        flkty[galleries.index(activeGallery.get(0))].resize();
    };

    const init = () => {
        galleries.each((gallery, index) => {
            flkty[index] = new Flickity(gallery, {
                cellSelector: '[data-item]',
                wrapAround: false,
                contain: true,
                pageDots: true,
                prevNextButtons: false,
                draggable: false,
                dragThreshold: 10,
                cellAlign: 'center',
                setGallerySize: true,
                percentPosition: true,
                accessibility: true,
                groupCells: true
            });
        });

        toggle.on('click', onToggle);
    };

    const destroy = () => {
        flkty.forEach(item => {
            item.destroy();
        });
    };

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/Gallery.js